import { RxCollection } from 'rxdb';
import { ColumnModel, ReferenceTableModel, TableModel } from '@shared';

export interface WorkspaceDatabaseDbContext {
	tables: RxCollection<TableModel>;
	columns: RxCollection<ColumnModel>;
	referencetables: RxCollection<ReferenceTableModel>;
}
